/**
 * Section settings shared by the builder panel and every screen that renders a
 * section title. Mirrors `SectionTitleAlign` / `SECTION_TITLE_FONT_SIZE` /
 * `SECTION_TITLE_DEFAULTS` in `@therapylake/package/form-builder` (used by AI form
 * generation) and the PDF's `reportMicroservice/src/formBuilder/converter/sectionLayout.util.ts`, and is copied in
 * `members_client/src/fragments/formRenderer/sectionTitleStyle.js`.
 */
export const SECTION_NAME_MAX_LENGTH = 50;

export const SECTION_TITLE_ALIGN = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
};

export const SECTION_TITLE_FONT_SIZE = { min: 8, max: 72 };

// Defaults of `.form-builder-section-title`, shown when the author has not changed them.
export const SECTION_TITLE_DEFAULTS = { fontSize: 16, color: '#172b4d', bold: true };

/** `formSettings.continuousSections` unset (templates saved before it) counts as on. */
export const isContinuousSections = (formSettings) => formSettings?.continuousSections !== false;

/** Index of the first section with a blank name, or -1. A blank name is not saved. */
export const findUnnamedSectionIndex = (sections) => (sections || []).findIndex((section) => !section?.name?.trim());
